import { createSlice } from "@reduxjs/toolkit";

import { TwoStepAuthData } from "store/meetings/types";

import {
  addUser,
  forgot,
  get2fa,
  getOwnProfile,
  login,
  login2fa,
  resetPassword,
  updateOwnProfile,
} from "./actions";
import { User } from "./types";

export const REGISTER_SUCCESS = "/auth/register/fulfilled";
export const RESET_PASSSWORD_SUCCESS = "/auth/reset-password/fulfilled";

export interface AuthState {
  error: any;
  token: null | string;
  loading: boolean;
  user: User | null;
  twoStepAuth: boolean;
  twoStepAuthData: TwoStepAuthData | null;
}

const initialState: AuthState = {
  loading: false,
  token: null,
  error: false,
  user: null,
  twoStepAuth: false,
  twoStepAuthData: null,
};

export const authSlice = createSlice({
  initialState,
  name: "auth",
  reducers: {
    logout: (state: AuthState) => {
      state.token = initialState.token;
      state.user = initialState.user;
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.twoStepAuth = initialState.twoStepAuth;
      state.twoStepAuthData = initialState.twoStepAuthData;
    },
    twoStepAuth: (state: AuthState, action) => {
      state.twoStepAuth = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(login.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(login.fulfilled, (state, action) => {
      state.loading = false;
      state.token = action.payload.token;
      state.user = action.payload.data;
      state.twoStepAuth = action.payload.twoStepAuth;
      state.error = false;
    });

    builder.addCase(login2fa.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(login2fa.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(login2fa.fulfilled, (state, action) => {
      state.loading = false;
      state.token = action.payload.token;
      state.user = action.payload.data;
      state.twoStepAuth = false;
      state.error = false;
    });

    builder.addCase(addUser.rejected, (state) => {
      state.loading = false;
      state.error = true;
    });
    builder.addCase(addUser.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(addUser.fulfilled, (state) => {
      state.loading = false;
      state.error = false;
    });

    builder.addCase(forgot.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(forgot.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(forgot.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
    });

    builder.addCase(resetPassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(resetPassword.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(resetPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
    });

    builder.addCase(get2fa.pending, (state, action) => {
      state.loading = true;
      state.error = false;
    });

    builder.addCase(get2fa.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.twoStepAuthData = action.payload.data;
    });

    builder.addCase(get2fa.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // UPDATE OWN PROFILE
    builder.addCase(updateOwnProfile.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(updateOwnProfile.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(updateOwnProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.user = action.payload.data;
      state.error = false;
    });

    builder.addCase(getOwnProfile.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getOwnProfile.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(getOwnProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.user = action.payload.data;
      state.error = false;
    });
  },
});

// Action creators are generated for each case reducer function
export const { logout, twoStepAuth } = authSlice.actions;
export default authSlice.reducer;
